import React, { Component } from 'react'
import SearchBar from '@common/SearchBar'
import { Input } from 'hljd'
import { observer } from 'mobx-react'
const Item = SearchBar.Item

@observer
export default class extends Component {
  render() {
    return (
      <div style={{ marginBottom: 15 }}>
        <SearchBar store={this.props.store} noNeed={['name']}>
          <Item label="活动名称" name="name">
            <Input style={{ width: 300 }} />
          </Item>
        </SearchBar>
      </div>
    )
  }
}
